const _version = require("../package").version;
export const version = () => _version;
export const drevo = (params) => {
    return params.root;
};
